import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { SentryService } from '@lmc-app/core/services/sentry.service';
import {
	MatCard,
	MatCardHeader,
	MatCardTitle,
	MatCardContent,
} from '@angular/material/card';
import { MatButton } from '@angular/material/button';

@Component({
	selector: 'app-debugging',
	templateUrl: './debugging.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrls: ['./debugging.component.scss'],
	imports: [MatCard, MatCardHeader, MatCardTitle, MatCardContent, MatButton],
})
export class DebuggingComponent implements OnInit {
	constructor(private sentryService: SentryService) {}

	ngOnInit(): void {}

	/**
	 * Throw a test error that will be automatically caught by Sentry ErrorHandler
	 */
	throwTestError(showReport: boolean): void {
		this.sentryService.captureException(
			new Error('Sentry Testing Error'),
			showReport
		);
	}
}
